export default __webpack_public_path__ + "static/media/tv2.133bf0b0.svg";